exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#http-loader {\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: fixed;\r\n    z-index: 9999;\r\n}\r\n\r\n.loader-bg {\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    filter: alpha(opacity=70);\r\n    opacity: .7;\r\n    background-color: #f1f1f1;\r\n}\r\n\r\n.colored-parent, .colored > div {\r\n    background-color: #333;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/app/spinner/spinner.component.css
// module id = ../../../../../src/app/spinner/spinner.component.css
// module chunks = main